<template>
    <v-card>
    <v-navigation-drawer
    v-model="right_drawer"
    app dark      
    right
    width="400px"
    >
      <template v-slot:prepend>
        <v-list-item >
         
          <v-list-item-icon>
           <v-icon> mdi-eye </v-icon>    
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">View Quiz</v-list-item-title>
            
          </v-list-item-content>
           <v-btn
          icon
          @click.stop="close_right_sidebar" 
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        </v-list-item>

        <v-list-item >
          <v-breadcrumbs large dark :items="b_items">
          <template v-slot:divider>
            <v-icon>mdi-forward</v-icon>
          </template>
     
           </v-breadcrumbs>
        </v-list-item > 


      

      </template>

      <v-divider></v-divider>

  <template>
  <v-form
    class="mx-2"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    
     <v-text-field
          :disabled="!editable"
          :rules="scoreRules"
          class="mt-2"
          v-model="score"
          max="10"
          min="1"
          step="1"
          style="width: 125px"
          type="number"
          @keydown="false">
          <template #label>
          <span class="red--text"><strong>* </strong></span>Quiz Score
         </template>
    </v-text-field>

     <v-textarea
          :disabled="!editable"
          :rules="questionRules"
          name="input-7-1"
          v-model="question"
          hint="Insert here the quiz question"
          :counter="200">
      <template #label>
      <span class="red--text"><strong>* </strong></span>Quiz Question
    </template>
    </v-textarea>


      <v-select
        :disabled="!editable"
        v-model="question_type"
        :items="question_types"
        label="Question Type"
        style="max-width: 250px;"
        
      ></v-select>

    <div v-if="question_type=='Multiple choice'">

     <v-text-field v-for= "answer in answers" :key=answer.index 
       :append-outer-icon="(answer.index > 2 && editable )? 'mdi-minus' : ''"
       @click:append-outer="remove_answer(answer.index)"
      :disabled="!editable"
      v-model="answer.value"
      :counter="200"
      :rules="answerRules"
      required>
     <template #label>
      <span class="red--text"><strong>* </strong></span>Answer {{answer.index}}
    </template>
    </v-text-field>

     <v-btn v-if="editable" small color="success"
     @click="add_answer"
      
      
    >
      <v-icon small left>mdi-plus</v-icon>
      Add Answer
    </v-btn>
   

    

    <v-select
          :disabled="!editable"
          class="mt-2"
          v-model="correct_answer"
          :items="potential_answers_choice"
          append-icon="mdi-thumb-up"
          menu-props="auto"
          outlined
          required
          :rules="correctAnswerRules">
     <template #label>
      <span class="red--text"><strong>* </strong></span>Select the Correct Answer
    </template>
    </v-select>

    </div>

     <div v-else>
     <v-select
      :disabled="!editable"
      class="mt-2"
      v-model="correct_answer"
      :items="yes_no_potential_answers_choice"
      append-icon="mdi-thumb-up"
      menu-props="auto"
      outlined
      required
      :rules="correctAnswerRules">
      <template #label>
      <span class="red--text"><strong>* </strong></span>Select the Correct Answer
    </template>
          
    </v-select>


    </div>

    <v-textarea
          :disabled="!editable"
          label="Correct Answer Explanation"
          v-model="explanation"
          hint="Insert here the explanation for the Correct Answer"
          :counter="500"

    ></v-textarea>



  
   
<v-btn
     
      color="success"
      class="mr-6 white--text"
      @click="undo"
    
    > 
    <v-icon left dark>{{edit_or_undo_icon}}</v-icon> {{edit_or_undo}}
      
      
    </v-btn>

   

    <v-btn
      :disabled="!editable"
      color="error"
      class="mr-6"
      @click="reset"
    >
      <v-icon left dark>mdi-eraser</v-icon> Reset Form
      
    </v-btn>
    <v-btn
      :disabled="!editable"
      color="success"
      class="mt-4"
      block
      @click="store_quiz"
      
    >
     <v-icon left>mdi-content-save</v-icon> Store Quiz
      
    </v-btn>
    <v-btn
      :disabled="!editable"
      color="error"
      class="mt-4"
      block
      @click="delete_dialog=true"
      
    >
     <v-icon left>mdi-delete</v-icon> Delete Quiz
      
    </v-btn>

   
  </v-form>
</template>
   
   

  

  

  

    </v-navigation-drawer>


    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="snackbar_color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackbar_text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

  


<template>
  <v-row justify="center">
    <v-dialog v-model="delete_dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Quiz?</v-card-title>
        <v-card-text>Are you sure you want to delete the Quiz? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="delete_quiz">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


  </v-card>


</template>

<script>
    import { componentBus } from '../main';
    import axios from 'axios';
    import {  APIS_BASE_URL } from '../constants';
    //import router from '../router';
    export default {
        name: 'QuizEdit',
        data: function () {
            return {

         b_items: [
        {
          text: 'Project',
          disabled: false,
          //href: 'project_edit?uuid=765e40d1-d8b5-4037-b68f-2d80096d0b15',
          //link: true,
         // exact: true,
          to: ''
        },
        {
          text: 'POI',
          disabled: false,
          to: ''
          //href: 'breadcrumbs_link_1',
        },
        {
          text: 'Quiz Editting',
          disabled: true,
          href: '',
        },
      ],            

        answers: null,
        potential_answers_choice: null,

        yes_no_potential_answers_choice: [{ text: 'No', value: 1},{ text: 'Yes', value: 2}],


        question_types: ['Multiple choice','Yes/No'],
        question_type: 'Multiple choice',

        delete_dialog: false,

        editable: false,
        quiz_uuid: null,


        snackbar_color: '',
        mode: '',
        snackbar: false,
        snackbar_text: '',
        timeout: 4000,
        x: null,
        y: 'top',


      waiting_for_storage: false,
      right_drawer: true,


      valid: true,
      answerRules: [
       v => !!v || 'This field is required',
       v => (v && v.length <= 200) || 'Answers must be less than 200 characters',
       
      ],
      questionRules: [
       v => !!v || 'This field is required',
       v => (v && v.length <= 200) || 'The question must be less than 200 characters',
       
      ],
      correctAnswerRules:  [
       v => !!v || 'This field is required'
       
       
      ],
      scoreRules: [
        v => !!v || 'Score is required',
        
       
      ],
  
      score: null,
      question: null,
      correct_answer: null,
      explanation: null,
      relevant_poi_uuid: null,
      relevant_project_uuid: null
      
      

                
            };
        },
        computed: {
            edit_or_undo: function () {
            
            return this.editable ? "Undo" : "Edit Quiz" 


            },
            edit_or_undo_icon: function () {
            
            return this.editable ? "mdi-undo" : "mdi-pencil" 


            }


        },
        methods: {

       add_answer()
        {
        let previous_answers_counter= this.answers.length;
        this.answers.push({index: previous_answers_counter+1, value: null});
        this.potential_answers_choice.push({text: "Answer "+(previous_answers_counter+1), value: (previous_answers_counter+1)  });

        },  



        reset () {
         this.$refs.form.reset()
        },
        undo () {
        if(this.editable)
            this.fetch_quiz_details();
        this.$refs.form.resetValidation();
        this.editable=!this.editable;
      

        },

        resetValidation () {
        this.$refs.form.resetValidation()
        },

        close_right_sidebar () {
        this.right_drawer = false;

      },
     
     
      fetch_quiz_details()
      {
        var get_quiz_url=APIS_BASE_URL+"/quiz/"+this.quiz_uuid+"/";
        var get_quiz_url_encoded= encodeURI(get_quiz_url);
   
        axios.get(get_quiz_url_encoded)
                    .then(response => {


                    this.score=response.data.score;
                    this.question= response.data.question;
                    //this.answers= response.data.answers;

                    this.answers= response.data.answers.map(  (item,index) =>  { 
                        
                      let object= {};
                      object['index']= index+1;
                      object['value']= item;      
                      return object;
                        
                      }
                      );




                    response.data.question_type == '1' ? this.question_type='Multiple choice' : this.question_type='Yes/No',
                  
                   
                    this.correct_answer=response.data.correct_answer;
                    this.explanation=response.data.explanation;
                    this.relevant_poi_uuid= response.data.relevant_poi;
                    this.quiz_uuid= response.data.quiz_uuid;

                    this.potential_answers_choice= this.answers.map(  (item,index) =>  { 
                        
                      let object= {};
                      object['text']= 'Answer '+(index+1);
                      object['value']= index+1;      
                      return object;
                        
                      }
                      );

              
   
                        
                    })
                    .catch(error => console.log(error));
      },
     

     
     


      delete_quiz()
      {
       this.delete_dialog=false;
       componentBus.$emit('poi_to_remove_quiz', this.relevant_poi_uuid);
       //if(this.multimedia_type==1) this.delete_project_image();
       //else if(this.multimedia_type==2) this.delete_project_video();
       let url_delete_quiz_query=APIS_BASE_URL+"/quiz/"+this.quiz_uuid+"/";
       let encoded_url_delete_quiz_query= encodeURI(url_delete_quiz_query);
       axios.delete(encoded_url_delete_quiz_query)
        .then((response) => {
         this.snackbar_color="success";
         this.snackbar_text="The Quiz has been successfully deleted!"
         this.snackbar=true;
        console.log(response.status);

        this.reset();
        this.close_right_sidebar();
        
        })


      },

       store_quiz()
        {
           
     
      
          let valid= this.$refs.form.validate();
        
          if( valid)    
          {
           this.waiting_for_storage=true;
           let url_query=APIS_BASE_URL+"/quiz/"+this.quiz_uuid+"/";
           let my_url= encodeURI(url_query);
           var payload = {
                      
                      
                    answers: this.question_type=="Multiple choice" ?  this.answers.map(  (item) => item.value) : ["No","Yes"],
   

                    score: this.score,
                    question: this.question,
                    //answer_a: this.first_answer,
                    //answer_b: this.second_answer,
                    //answer_c: this.third_answer,
                    //answer_d: this.fourth_answer,
                    correct_answer: this.correct_answer,
                    explanation: this.explanation,
                    published: true,
                    created_by: "aaabbbccc",
                    relevant_poi: this.relevant_poi_uuid,
                    question_type: this.question_type=="Multiple choice" ? 1 : 2
                   
                
                   
                }

           
           axios.put(my_url, payload,
                    {
                     headers: { 'Content-Type' : 'application/json'}
                               
                        }).then(response => {
                            if (response.status == "200" || response.status == "201" ) {
                               this.waiting_for_storage=false;
                               this.snackbar_color="success";
                               this.snackbar_text="The Quiz has been successfully updated!"
                               this.snackbar=true;

                               payload["quiz_uuid"]=this.quiz_uuid;
                               componentBus.$emit('updated_quiz_payload', payload);

                               
                               //payload.id=response.data.id;
                               //payload.uuid=response.data.project_uuid;
                               //componentBus.$emit('newly_created_project', payload);

                               //now store the file as well
                             
                              
                               
                               //console.log(response.data);
                            }
                            else {
                                //alert("something went wrong");
                                this.waiting_for_storage=false;
                                this.snackbar_color="error";
                                this.snackbar_text="Problem with the Quiz update..."
                                this.snackbar=true;
                            }
                            //this.reset();
                            this.editable=false;
                    })
                    .catch(error => {
                        console.log(error);
                        //alert("something went wrong"+ error);
                        this.waiting_for_storage=false;
                        this.snackbar_color="error";
                        this.snackbar_text="Problem with the Quiz update..."
                        this.snackbar=true;
                    });


 
          }
          
        

        }

       
       
        },

         
     

        
        mounted() {

        componentBus.$on('quiz_to_edit_uuid', quiz_uuid => {
        this.right_drawer = true;
        this.quiz_uuid= quiz_uuid;
        this.fetch_quiz_details();

            });

         

        
         this.quiz_uuid= this.$route.query.quiz_uuid;
         this.fetch_quiz_details();
         this.relevant_poi_uuid= this.$route.query.poi_uuid;
         this.relevant_project_uuid= this.$route.query.project_uuid;
         this.b_items[1]['to']='poi_edit?poi_uuid='+this.relevant_poi_uuid+'&project_uuid='+this.relevant_project_uuid;
         this.b_items[0]['to']='project_edit?uuid='+this.relevant_project_uuid;
         

    
           
        },
        destroyed() {
          componentBus.$off('quiz_to_edit_uuid');
          

           
        }
    }
</script>

<style scoped>
   
</style>
